import { INITIALIZE_REPORT_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_REPORT_FORM](values);
